const Features = () => {
  const features = [
    {
      icon: '🃏',
      title: 'Live support cards',
      description:
        'Teach Claude “meeting skills” — playbooks with a “fires when…” hint — by chatting with the built-in skills assistant. In-meeting skills watch the live transcript and surface compact, beautifully rendered cards the moment they’re relevant: pricing talking points, objection counters, anything you’ve taught it.',
      result: 'The answer is on the table before you think to ask.',
    },
    {
      icon: '💬',
      title: 'Ask Claude mid-meeting',
      description:
        'A chat that already knows the transcript-so-far and your own notes. “What were his three priorities?” gets answered from what was actually said — while the meeting is still happening.',
      result: 'No more “let me get back to you on that.”',
    },
    {
      icon: '🪪',
      title: 'Voice recognition speaker ID',
      description:
        'After the meeting, real diarization names every line — no bot needed. The app learns voices across meetings, you confirm who’s who, and you can adjust the speaker count when it guesses wrong.',
      result: '“Priya: ship it Friday” — not “Speaker 2: …”.',
    },
    {
      icon: '🗂️',
      title: 'Meeting categories & note styles',
      description:
        'A sales call deserves different notes than a standup. Assign a category — 1:1, standup, sales call, or your own — and Claude writes the summary in the note style you defined for it.',
      result: 'Summaries shaped like the meeting, not a template.',
    },
    {
      icon: '➡️',
      title: 'Next steps straight into Claude',
      description:
        'Each next step is a one-click handoff: claude.ai opens with a fully-briefed prompt — context, decisions, who asked. The follow-up conversation lives in your real Claude history.',
      result: 'Action items that arrive already briefed.',
    },
    {
      icon: '📤',
      title: 'Notes anywhere via MCP',
      description:
        'Deliver meeting notes through your own MCP servers — Notion, Linear, Slack, Obsidian, Google Drive, anything with an MCP server. Your accounts, your credentials, no connector fees.',
      result: 'Notes land where your team already works.',
    },
  ];

  return (
    <section className="features" id="features">
      <div className="section-container">
        <p className="overline overline--center">WHAT IT DOES</p>
        <h2 className="section-title">A meeting copilot that works while you talk</h2>
        <p className="section-subtitle">
          Notetakers email you a summary after it’s over. Solidly Meet puts Claude in the room with
          you — briefing you before, supporting you live, then turning the conversation into named
          speakers, shaped notes, and follow-ups that are already moving.
        </p>

        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {f.icon}
              </div>
              <h3>{f.title}</h3>
              <p>{f.description}</p>
              <p className="feature-result">{f.result}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
